import type { IDrawingBase } from 'types/IDrawingBase';
import { PrizeType } from 'types/IPrize';

/**
 * A Ziehungsbasis can only be used for a drawing once it has prizes and every
 * Sachgewinn carries a title and a description. The old app decided the same
 * way (`DrawingBase.isComplete`) and simply left out the "use" icon otherwise.
 */
export const isDrawingBaseComplete = (base: IDrawingBase): boolean => {
  const prizes = base.dbasePrizes ?? [];
  if (prizes.length === 0) return false;

  return prizes
    .filter((prize) => Number(prize.typ) === PrizeType.SACHGEWINN)
    .every((prize) => Boolean(prize.title?.trim()) && Boolean(prize.description?.trim()));
};
